var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkill6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.1765 9.88235V38.1176H31.0588C28.7197 38.1176 26.8235 40.0138 26.8235 42.3529H21.1765C21.1765 40.0138 19.2802 38.1176 16.9412 38.1176H2.82353V9.88235H0V43.7647H13.2629C15.977 43.7647 18.4963 45.1129 20.0019 47.3713L20.421 48H27.5791L27.9982 47.3713C29.5038 45.1129 32.0232 43.7647 34.7373 43.7647H48V9.88235H45.1765Z",
    fill: "var(--fill-0, #B707AB)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.5882 39.5294V35.2941C22.5882 33.7372 21.3216 32.4706 19.7647 32.4706H11.2941V5.64706H5.64706V35.2941H18.3529C20.6884 35.2941 22.5882 37.194 22.5882 39.5294Z",
    fill: "var(--fill-0, #B707AB)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24 33.8824V7.05882C24 3.16038 20.8397 0 16.9412 0H14.1176V29.6471H18.3529C21.4717 29.6471 24 30.7636 24 33.8824ZM42.3529 35.2941V5.64706H32.4706C32.4489 5.64706 32.4272 5.64715 32.4056 5.64734C29.3103 5.67068 26.8235 8.21054 26.8235 11.3059V36.376C27.5735 35.7038 28.5631 35.2941 29.6471 35.2941H42.3529ZM31.0588 16.9412H39.5294V19.7647H31.0588V16.9412ZM31.0588 22.5882H39.5294V25.4118H31.0588V22.5882ZM31.0588 28.2353H39.5294V31.0588H31.0588V28.2353Z",
    fill: "var(--fill-0, #B707AB)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill6);
export default __webpack_public_path__ + "static/media/skill-6.5461b7c0be4b4876d64a3070c940fe49.svg";
export { ForwardRef as ReactComponent };